import { render, staticRenderFns } from "./PermissionWarning.vue?vue&type=template&id=1d54be94&scoped=true"
import script from "./PermissionWarning.vue?vue&type=script&lang=js"
export * from "./PermissionWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54be94",
  null
  
)

export default component.exports